import { DatenauswertungGenerisch } from '../datenauswertung/DatenauswertungGenerisch';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import { getConfig as getConfigBasis } from './vsme/getConfigBasis';
import { getConfig as getConfigPat } from './vsme/getConfigPat';
import { getConfig as getConfigBpm } from './vsme/getConfigBpm';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { SectionStyle } from '../../helpers/SectionStyle';
import style from '../datenauswertung/datenauswertung.less';

interface DatenauswertungVsmeProps extends React.ClassAttributes<any> {
    data: any;
    routing: any;
    standortTid: number;
    standortName: string;
    jahr?: number;
    contentOnly?: boolean;
    onRoutingChange: (routing: any) => void;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungVsmeState {
    jahr: number;
    jahrMax: number;
    jahrMin: number;
    pdfString?: string;
    renderButton: JSX.Element;
}

export class DatenauswertungVsme extends React.Component<DatenauswertungVsmeProps, DatenauswertungVsmeState> {

    constructor(props: any) {
        super(props);
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;

        this.state = {
            jahr: this.props.jahr || jahrMax - 1,
            jahrMax,
            jahrMin,
            renderButton: undefined
        };
    }

    private sectionColor: string;

    componentDidUpdate(prevProps: any): void {
        if (this.props.jahr !== prevProps.jahr) {
            this.setState({ jahr: this.props.jahr || this.state.jahrMax - 1 });
        }
    }

    getConfig(): any {
        const { jahr } = this.state;
        const jahrVon: number = jahr - 2;
        const configBasis: any = getConfigBasis(this.props.data, jahrVon, jahr, this.props.standortTid) || {};
        const configBasis_docs: any = getConfigBasis(this.props.data, jahrVon, jahr, this.props.standortTid, 'docx') || {};
        const configBpm: any = /*getConfigBpm(this.props.data, jahrVon, jahr, this.props.standortTid) || */{};
        const configPat: any = getConfigPat(this.props.data, jahrVon, jahr, this.props.standortTid) || {};
        const range: number = jahr - jahrVon + 1;
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        let numCols = 2 + range;
        const baseWidth: number = 100 / numCols;
        const colWidths: number[] = [0.36, 0.91]; // [0] = Modul, [1] = Jahr

        return {
            titel0: unternehmen,
            titel1: `VSME/Jahr ${jahr}`,
            // titel2: (this.props.standortName || '').toString().replace(/(^(Veranstaltung|Standort)\:\ )/, ''),
            titel2: (this.props.standortName || '').toString().replace(new RegExp("^(\\b" + i18n('Veranstaltung', 'sys') + "\\b|\\b" + i18n('Standort', 'sys') + "\\b)\:\ "), ''),
            filename: `Auswertung_VSME_Jahr_${jahr}.pdf`,
            width: 800,
            baseWidth,
            header: { blocks: [] },
            rows: [
                ...(configBasis.rows || []),
                ...(configPat.rows || []),
                ...(configBpm.rows || [])
            ],
            docxRows: [
                ...(configBasis_docs.rows || []),
                ...(configPat.rows || []),
                ...(configBpm.rows || [])
            ],
            rows_width: [
                baseWidth * colWidths[0],
                baseWidth * (numCols - colWidths[0] - (range * colWidths[1])),
                ...Array.from(Array(range).keys()).map((_) => baseWidth * colWidths[1])
            ],
            custom_row_classes: [
                ...(configBasis.custom_row_classes || []),
                ...(configPat.custom_row_classes || []),
                ...(configBpm.custom_row_classes || [])
            ]
        };
    }

    render(): JSX.Element {
        return <>
            {!this.props.setJSXdirect &&
                <div className={style.datenauswertungOuterFormContainer}>
                    <DatenauswertungJahrauswahlEinzeln
                        jahrMax={this.state.jahrMax}
                        jahrMin={this.state.jahrMin}
                        jahr={this.state.jahr}
                        externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                        onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                    />
                    {/*<div style={{ padding: 5, paddingRight: 20 }}>
                        {this.renderHelpIcon()}
                    </div>*/}
                </div>
            }
            <DatenauswertungGenerisch
                config={this.getConfig()}
                orientation='portrait'
                setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                setJSXdirect={this.props.setJSXdirect}
                callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                pdfButtonStyle={{ color: 'white', backgroundColor: this.sectionColor, padding: '1px 8px 1px 2px' }}
                docxExport
                contentOnly={this.props.contentOnly}
            />
        </>;
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='vsme'
                styleProps={{ color: 'white', backgroundColor: this.sectionColor, padding: '1px 8px 1px 2px' }}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const path: any = RoutingIDs.ROUTE_DATENEINGABE;

        return (
            <WActionButton
                label='Dateneingabe'
                insideText='Dateneingabe'
                tooltip='Zum Dateneingabebereich springen'
                key='dateneingabe'
                action='edit'
                styleProps={{ color: 'white', backgroundColor: this.sectionColor, padding: '1px 8px 1px 2px' }}
                onAction={() => this.props.onRoutingChange({ path })}
            />
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{
                    verticalAlign: 'top', color: 'white', backgroundColor: '#ed7d31', width: 18, height: 18, margin: 0, borderRadius: 10
                }}
                label='Datenauswertung - Hinweise'
                helpKey='datenauswertung_vsme'
                type='info'
                editBar
            />
        );
    }

    setColors(): void {
        this.sectionColor = (SectionStyle.getSectionColors() || {}).datenauswertung;
    }
}
